<app-common-modal-wrapper
  icon="ic-refresh-20"
  header="Update Director ID"
  [isLoading]="isLoading()"
  (close)="close()"
  (submitModal)="submit()"
>
  <div class="d-flex flex-column gap-24">
    <app-din-masked-input
      [formControl]="dinControl"
    />
    <app-disclaimer
        color="orange"
        icon="ic-info-circle-20">
          {{message}}
    </app-disclaimer>
  </div>
</app-common-modal-wrapper>
